<template>
  <img v-if="src !== null" :src="src" />
</template>
<script>
const toBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
});

export default {
  props: ['image'],
  data() {
    return {
      src: ''
    };
  },
  watch: {
    image() {
      this.getSrc();
    }
  },
  created() {
    this.getSrc();
  },
  methods: {
    async getSrc() {
      if (typeof this.image === 'string') {
        this.src = this.image;
      } else if (this.image instanceof Blob) {
        this.src = await toBase64(this.image);
      }
    }
  }
};
</script>
